import { useAuth } from "@/auth/contexts/AuthProvider";
import { useSnackbar } from "@/core/contexts/SnackbarProvider";
import { CustomTypes } from "@/shared-types/v1";
import { useRef, useState } from "react";

export type MergeDataFunction = (
  partialSettings: Partial<CustomTypes.DynamicAppSettings>
) => void;

export const useHandleDynamicSettings = () => {
  const { equestrain, dataLoading } = useAuth();
  const snackbar = useSnackbar();

  const touchedRef = useRef(0);
  const [data, setData] = useState<CustomTypes.DynamicAppSettings>();
  const mergeData: MergeDataFunction = (partialSettings) => {
    const newData = { ...data, ...partialSettings };
    setData(newData);
    if (touchedRef.current === 0) {
      touchedRef.current += 1;
    }
  };
  const handleSave = async () => {
    touchedRef.current = 0;
    if (data) {
      const res = await equestrain.Legacy.editAppSettings(data);
      if (res.error) {
        snackbar.error(res.error.message);
        return;
      }
    }
  };
  const handleGetAppSettings = async () => {
    if (data !== undefined) {
      return;
    }
    const res = await equestrain.Legacy.getAppSettings();
    if (res.error) {
      snackbar.error(res.error.message);
      return;
    }
    if (res.data) {
      setData(res.data);
    }
  };

  const isTouched = touchedRef.current > 0;
  return {
    data,
    mergeData,
    handleSave,
    isTouched,
    dataLoading,
    handleGetAppSettings,
  };
};
